export const conditionTimeOperandTypeToBackend = {
  at_this_time: 'eq',
  between_these_times: '',
  before_this_time: 'lt',
  after_this_time: 'gt',
}
